/**
 * @fileoverview Prescriptor Settings Page
 * Contains tabs for managing Patient Status Reasons and Prescription Reasons
 */
import React from "react";
import { DmsPage, DmsTabber, DmsAltBox, intl } from "dmsbasereact";
import { Typography } from "@mui/material";
import { PatientStatusReasonTable } from "../../components/PatientStatusReasonTable";
import { PrescriptionReasonTable } from "../../components/PrescriptionReasonTable";

export const PrescriptorSettingsPage = () => {
  const tabs = [
    {
      title: intl.get("PatientStatusReasons").d("Patient Status Reasons"),
      component: <PatientStatusReasonTable />,
    },
    {
      title: intl.get("PrescriptionReasons").d("Prescription Reasons"),
      component: <PrescriptionReasonTable />,
    },
  ];

  return (
    <DmsPage name={intl.get("PrescriptorSettings").d("Prescriptor Settings")}>
      <DmsAltBox.Card>
        <DmsAltBox.Header>
          <Typography variant="h6">
            {intl.get("PrescriptorSettings").d("Prescriptor Settings")}
          </Typography>
        </DmsAltBox.Header>
        <DmsAltBox.Body>
          <DmsTabber tabs={tabs} pageName={intl.get("PrescriptorSettings").d("Prescriptor Settings")} />
        </DmsAltBox.Body>
      </DmsAltBox.Card>
    </DmsPage>
  );
};

export default PrescriptorSettingsPage;
